import { ReactNode, useEffect } from 'react'
import Header from './Header'
import Footer from './Footer'
import { ACTIVE_DESIGN_SYSTEM } from '@/config/designSystem'

interface LayoutProps {
  children: ReactNode
}

const Layout = ({ children }: LayoutProps) => {
  useEffect(() => {
    document.documentElement.setAttribute('data-design-system', ACTIVE_DESIGN_SYSTEM)
  }, [])

  return (
    <div
      className="min-h-screen bg-m2-background flex flex-col font-body text-m2-on-surface"
      data-design-system={ACTIVE_DESIGN_SYSTEM}
    >
      <Header />
      <main className="flex-1">{children}</main>
      <Footer />
    </div>
  )
}

export default Layout
